import { useQuery } from "react-query";
import endpoints from "./EndPoints";
import { getAdvertDuration30Day, getAdvertDurationStats, getCategoryBasedAdvertCounts, getMessageResponseTime, getUnansweredMessages } from "./Services";



export const useGetCategoryBasedAdvertCounts= (filter:any) => {
  const query = useQuery(
    [endpoints.getCategoryBasedAdvertCounts,filter],
    () => {
      return getCategoryBasedAdvertCounts(filter);
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );

  return query;
};

export const useGetAdvertDurationStats= (filter:any) => {
  const query = useQuery(
    [endpoints.getAdvertDurationStats,filter],
    () => {
      return getAdvertDurationStats(filter);
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );

  return query;
};

export const useGetAdvertDuration30Day= (filter:any) => {
  const query = useQuery(
    [endpoints.getAdvertDuration30Day,filter],
    () => {
      return getAdvertDuration30Day(filter);
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );

  return query;
};

export const useGetMessageResponseTime= (filter:any) => {
  const query = useQuery(
    [endpoints.getMessageResponseTime,filter],
    () => {
      return getMessageResponseTime(filter);
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );

  return query;
};

export const useGetUnansweredMessages= (filter:any) => {
  const query = useQuery(
    [endpoints.getUnansweredMessages,filter],
    () => {
      return getUnansweredMessages(filter);
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );

  return query;
};